/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/morkhasi-request',
  name: 'morkhasiRequest',
  component: () => import('@/views/morkhasi/Request'),
},
{
  path: '/morkhasi-history',
  name: 'morkhasiHistory',
  component: () => import('@/views/morkhasi/Index'),
}
]

